import { defaultDataIdFromObject, StoreObject } from '@apollo/client'

export const responseObjects = (responseObject: Readonly<StoreObject>) => {
  switch (responseObject.__typename) {
    default:
      return defaultDataIdFromObject(responseObject)
  }
}
